<template>
<div class="page_smart_park pB100">
	<div class="appoint">
		<!-- 选择参观日期 -->
		<div class="riqi_wrap">
			<div class="title">
				<span class="">选择参观日期</span>
				<span class="" @click="showPicker = true">{{ year+'.'+month}}</span>
			</div>
			<div class="riqi">
				<!-- item.is_today && item.is_have  ? 'item today' : item.is_today && !item.is_have ? 'item today unable' : !item.is_have ? 'item unable': item.is_select ? 'item selected' : 'item'  -->
				<div :class="!item.is_have ? 'item unable': item.is_select ? 'item selected': item.is_today ? 'item today' : 'item' " v-for="(item,index) in totalTickteList" :key="index" @click="selectDate(item)">
					<span class="">{{ item.date_at }}</span>
					<span class="">{{ item.is_have ? '余'+item.shengyu : '无票'}}</span>
				</div>
				<div class="item" v-if="showMore" @click="loadeMoreFun">
					<span class="">其他日期</span>
				</div>
			</div>
		</div>
		<!-- 选择入馆时段 -->
		<div class="riqi_wrap">
			<div class="title">
				<span class="">选择入馆时段</span>
			</div>
			<div class="riqi section">
				<div :class="!item.is_buy ? 'item unable' : item.is_select ? 'item selected' : 'item'" v-for="item in ticketList" :key="item.id" @click="bindTicket(item)">
					<span class="">{{ item.beigin_at +'-'+ item.end_at }}</span>
					<div v-if="is_tuanti==1">
						<span class="" v-if="item.is_buy">{{ (item.store_team_num <= 0) ? '无票' : '有票'}}</span>
					</div>
					<div v-else>
						<span class="" v-if="item.is_buy">{{ (item.store <= 0) ? '无票' : '有票'}}</span>
					</div>
					<span class="" v-if="!item.is_buy">无票</span>
				</div>
				<!-- <div class="item selected">
					<span class="">09:00-10:00日</span>
					<span class="">有票</span>
				</div>
				<div class="item unable">
					<span class="">09:00-10:00日</span>
					<span class="">有票</span>
				</div>
				<div class="item">
					<span class="">09:00-10:00日</span>
					<span class="">有票</span>
				</div>
				<div class="item unable appointed">
					<span class="">09:00-10:00日</span>
					<span class="">衡水山木枝技术服务有限公司</span>
				</div> -->
			</div>
		</div>
		<!-- 温馨提示 -->
		<div class="info noborder" v-if="notices&&notices.length>0">
			<div class="title">温馨提示</div>
			<div class="item">
				<div class="text" v-for="notice in notices" :key="notice">{{notice}}</div>
			</div>
		</div>
	</div>
	<div class="bottom">
		<div class="action big" @click="toBuyTicket">预约参观票</div>
	</div>
	<!-- 日期选择 -->
	<van-popup v-model="showPicker" position="bottom">
		<van-datetime-picker
		v-model="currentDate"
		type="year-month"
		:min-date="minDate"
		@confirm="confirmTime"
		@cancel="showPicker = false"
		/>
	</van-popup>
	<van-popup v-model="showSafeView" position="center" style="border-radius: 10px;">
		<div class="safe_view">
			<div class="safe_view_top">
				<div class="safe_view_top_title">参观须知</div>
				<div class="safe_view_top_close" @click="showSafeView=false">
					<img :src="publicPath+'statics/images/safe_close.png'" alt="">
				</div>
			</div>
			<div class="safe_view_content">
				<div v-html="safeNotice"></div>
			</div>
			<div :class="safeTime>0?'safe_view_wait':'safe_view_done'" @click="realBuy">{{safeTime>0?('请仔细阅读须知（'+safeTime+'s）'):'预约参观票'}}</div>
		</div>
	</van-popup>
	<!-- 无次卡的提示框 -->
	<van-dialog v-model="show_tips" title="您当前暂无可用次卡,是否继续购票？" show-cancel-button @confirm="continueToBuyTicket"></van-dialog>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			id: 1, // id是后台配的,先直接写死1
			year: null,
			month: null,
			day: null,
			showPicker: false,
			currentDate: new Date(),
			minDate: new Date(),
			is_through_ticket: this.$route.query.is_through_ticket, // 是否通票 1是 0否
			venue_id: this.$route.query.venue_id, // 场馆ID
			ticketList: null, // 票列表
			lastDate: null, // 请求到的最后一天(每次返回8天,点击更多拿最后一天再次请求)
			showMore: true, // 是否显示其他日期
			newTickteList: [], // 当前请求到的票务信息
			totalTickteList: [], // 总的票务信息
			notices: [], // 场馆提示
			perNum: 8, // 每次加载的天数
			userTicket: null, // 用户已选的票信息
			parkInfo: null,
			showSafeView: false,
			safeTime: 3,
			safeNotice: null,
			is_tuanti: this.$route.query.is_tuanti, // 1是 0否
			is_cika: this.$route.query.is_cika, // 1是 0否
			show_tips: false // 默认 不提示(当用户通过次票过来,如无次票,则提示)
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
		var that = this
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '预约',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
        }
		// 先清一下
		localStorage.removeItem('userTicket')
		// 场馆提示
		if(that.venue_id){
			that.getShopDetail()
		} else {
			that.getParkData()
		}
		// 为默认日期赋值 默认为当天 例 2021-03-12
		var today = new Date()
		that.timeFormat(today)
    },
	mounted() {
	},
    methods: {
		// 获取园区信息
		getParkData(){
			var that = this
			var params = {
				id: that.id
			}
			that.$api.smartpark.index(params).then(res=>{
				if(res.code == 200){
					that.parkInfo = res.result
					that.safeNotice = res.result.notice_throughticket
				}
			})
		},
		// 获取场馆提示
		getShopDetail(){
			var that = this
			var params = {
				venue_id: that.venue_id
			}
			that.$api.smartpark.venuedetail(params).then(res=>{
				if(res.code == 200){
					if (that.is_tuanti == 1) {
						that.notices = res.result.team_notice.split('\n')
						that.safeNotice = res.result.notice_team
					} else {
						that.notices = res.result.notice.split('\n')
						that.safeNotice = res.result.notice_user
					}
					
				}
			})
		},
		// 获取票务信息(一次查8天)
		getData(){
			var that = this
			var params = {
				is_through_ticket: that.is_through_ticket,
				date_at: that.year+'-'+that.month+'-'+that.day,
				// date_at: '2021-04-09',
			}
			// 场馆ID
			if(that.venue_id){
				params.venue_id = that.venue_id
			}
			that.$api.smartpark.ticketlist(params).then(res=>{
				if(res.code == 200){
					// 重组数据,分日期和场次
					var list = res.result
					// console.log('list',list)
					var newTickteList = []
					if(list && list.length != 0 ){
						list.map(function(value,index,arr){
							var is_have = false
							// console.log('是否存在===',is_have)
							for (var j = 0; j < newTickteList.length; j++) {
								if (newTickteList[j].date_at == value.date_at) {
									is_have = true;
									break;
								}	
							}
							if (!is_have) {	
								newTickteList.push({ date_at: value.date_at, list: [] });
							}
							
							for (var i = 0; i < newTickteList.length; i++) {
								if (newTickteList[i].date_at == value.date_at) {
									// console.log('1111')
									// 日期信息 判断是否为当天
									newTickteList[i].is_today = that.isTodayFun(newTickteList[i].date_at)
									// 票务信息
									newTickteList[i].list.unshift(value);
									var sales = 0 // 当天总销量
									var store = 0 // 当天总库存
									for(var k in newTickteList[i].list){
										var item = newTickteList[i].list[k]
										if (that.is_tuanti == 1) {
											sales += item.sale_team_num
											store += item.store_team_num
											// 判断场次时间,是否允许购买(结束时间与当前时间比较)
											if (item.store_team_num > 0) {
												newTickteList[i].list[k].is_buy = 1
											} else {
												newTickteList[i].list[k].is_buy = 0
											}
										} else {
											sales += item.sales
											store += item.store
											// 判断场次时间,是否允许购买(结束时间与当前时间比较)
											if (item.store > 0) {
												newTickteList[i].list[k].is_buy = 1
											} else {
												newTickteList[i].list[k].is_buy = 0
											}
										}
										
										 // that.isBuyFun(item.date_at,item.end_at)
										// 是否选中,默认不选中,用于控制选中效果
										newTickteList[i].list[k].is_select = false
									}
									newTickteList[i].sales = sales
									newTickteList[i].store = store
									// 票务状态
									if(newTickteList[i].store <= 0){
										newTickteList[i].is_have = 0 // 库存小于0 售空, 无票, 赋值0
									}else{
										newTickteList[i].is_have = 1 // 1 有票
										if(newTickteList[i].is_today){
											newTickteList[i].is_select = true
										}
										newTickteList[i].shengyu = newTickteList[i].store
									}
									break;
								}
							}
							that.newTickteList = newTickteList
							
						})
					}else{
						var arr = []
						var obj = {
							// date_at: '2021-04-09',
							date_at: that.year+'-'+that.month+'-'+that.day,
							is_have: 0,
							is_today: that.isTodayFun(that.year+'-'+that.month+'-'+that.day),
							list: []
						}
						arr.push(obj)
						that.newTickteList = arr
					}
					that.loadeEmptyFun()
				}
			})
		},
		// 补齐每次加载的天数 
		loadeEmptyFun(){
			var that = this
			var dateArr = []
			// console.log('当天===',that.day)
			// console.log('当月最后一天',that.lastDayOfMonth)
			var oldList = that.newTickteList
			// 8天的日期
			for(var i = 0 ; i < that.perNum ; i++){
				var riqi = parseInt(that.day)+ i
				if(riqi <= that.lastDayOfMonth){
					var obj = {
						date_at: that.year+'-'+that.month+'-'+(riqi >= 10? riqi : '0'+riqi),
						is_have: 0,
						is_today: 0,
						list: []
					}
					dateArr.push(obj)
				}else{
					that.showMore = false
					break
				}
			}
			// 8天的票
			for(var j in dateArr){
				for(var k in oldList){
					if(dateArr[j].date_at == oldList[k].date_at){
						dateArr[j] =  oldList[k]
					}
					// console.log('后台返回的票===',oldList[k].date_at)
				}
			}			
			console.log('日期们====',dateArr)
			// var list = that.newTickteList
			// console.log('票=====',list)
			// var length = list.length
			// var maxLength = that.perNum - length
			// var lastDay
			// if(length != 0){
			// 	lastDay = list.slice(-1)[0].date_at.split('-')[2] // 现加载到的数据中最后一天
			// }else{
			// 	lastDay = parseInt(that.day)
			// }
			// for(var i = 1 ; i <= maxLength ; i++ ){
			// 	var day = parseInt(lastDay) + i
			// 	if(day > that.lastDayOfMonth){
			// 		that.showMore = false
			// 		break;
			// 	}
			// 	// console.log('日期',day)
			// 	var item = {
			// 		date_at: that.year+'-'+that.month+'-'+ (day >= 10 ? day : '0'+day),
			// 		is_have: 0,
			// 		is_today: 0,
			// 		list: []
			// 	}
			// 	list.push(item)
			// }
			// 当前最后一天 格式 2021-03-23
			that.lastDate = dateArr.slice(-1)[0].date_at
			// 现有全部天数及票务信息 
			// that.totalTickteList = that.totalTickteList.concat(list)
			that.totalTickteList = that.totalTickteList.concat(dateArr)
			// 默认展示第一天的票(也就是当天的票)
			that.ticketList = that.totalTickteList[0].list // 默认取第一个
			// that.ticketList[0].is_select = true
			console.log('票务信息',that.ticketList)
			console.log('全部的票',that.totalTickteList)
		},
		// 加载更多日期 拿上一次请求到的最后一天的下一天 去请求数据
		loadeMoreFun(){
			var that = this
			var lastDateArr = that.lastDate.split('-')
			that.year = lastDateArr[0]
			that.month = lastDateArr[1]
			that.day = parseInt(lastDateArr[2]) + 1 > 10 ? parseInt(lastDateArr[2]) + 1 : '0'+ ( parseInt(lastDateArr[2]) + 1)
			console.log('下次请求的第一天',that.year,that.month,that.day)
			that.getData()
		},
		// 选择购票日期时,获取相应的票
		selectDate(item){
			console.log('选择购票====',item)
			var that = this
			that.userTicket = null
			if(!item.is_have){
				that.$toast('无票')
				return
			}
			var currentDay = item.date_at
			// var list = that.newTickteList
			var list = that.totalTickteList
			console.log('选择购票日期',list)
			for(var i in list){
				if(currentDay == list[i].date_at){
					list[i].is_select = true
					that.ticketList = list[i].list
					// 切换日期时,票务时段置空
					for(var k in that.ticketList){
						that.ticketList[k].is_select = false
					}
				}else{
					list[i].is_select = false
				}
			}
		},
		// 选择时间段,拿票id
		bindTicket(item){
			var that = this
			if(!item.is_buy){
				that.$toast('不可购买')
				return
			}
			var list = that.ticketList
			for(var i in list){
				if(list[i].id == item.id){
					// console.log('11111')
					list[i].is_select = true
					// 存一下用户选中的票
					that.userTicket = list[i]
				}else{
					list[i].is_select = false
				}
			}
			that.ticketList = []
			that.ticketList = list
			// console.log('票信息',item)
		},
		// 去买票
		toBuyTicket(){
			var that = this
			if(!that.userTicket){
				that.$toast('请先选票')
				return
			}
			that.showSafeView = true
			that.updateBuy()
		},
		updateBuy() {
			var that = this
			setTimeout(() => {
				that.safeTime = that.safeTime-1
				if (that.safeTime > 0) {
					that.updateBuy()
				}
			}, 1000);
		},
		realBuy() {
			var that = this
			if (that.safeTime > 0) {
				return
			}
			if(!that.userTicket){
				that.$toast('请先选票')
				return
			}else{
				// 次票 先判断是否有次卡,无次卡给提示
				if(that.is_cika == 1){	
					that.getUserTimesCard()
				}else{
					// 非次票 继续购票
					that.continueToBuyTicket()
				}
			}
		},
		// 判断是否有卡
		getUserTimesCard(){
			var that = this
			var params = {
				token: that.token,
				smarkpark_id: that.userTicket.smarkpark_id,
				is_through_ticket: that.userTicket.is_through_ticket,
				venue_id: that.userTicket.venue_id,
				ticket_id: that.userTicket.id
			}
			that.$api.smartpark.setinfo(params).then(res=>{
				if(res.code == 200){
					// console.log('走进来了吗====')
					// 次卡
					var list = res.result.user_times_card
					if(list.length != 0){
						// 有卡不提示 继续购票
						that.show_tips = false
						that.continueToBuyTicket()
					}else{
						// 无卡给提示
						that.show_tips = true
					}
				}
			})
		},
		// 无卡但继续购票
		continueToBuyTicket(){
			var that = this
			localStorage.setItem('userTicket',JSON.stringify(that.userTicket))
			
			if(that.is_tuanti == 1){
				if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
					//获取用户信息
					var memberParams = {
						data: {
						},
					};
					this.$bridge.callhandler( "sdjy://member/memberInfo", memberParams, (data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							var params = {
								'data': {
									'url': that.$publicData.clientUrl + '/smart/park/tuanti'
									}
								}
							that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

							})
						} else {
							this.token = "";
						}
								// 调用某方法
					});
					
				} else {
					// 团体票
					that.$router.push('/smart/park/tuanti')
				}
				
			}else{
				if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
					//获取用户信息
					var memberParams = {
						data: {
						},
					};
					this.$bridge.callhandler( "sdjy://member/memberInfo", memberParams, (data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							var params = {
								'data': {
									'url': that.$publicData.clientUrl + '/smart/park/personal?is_cika='+that.is_cika
								}
							}
							that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

							})
						} else {
							this.token = "";
						}
								// 调用某方法
					});
					
				} else {
					// 散客票
					that.$router.push({
						path: '/smart/park/personal',
						query: {
							is_cika: that.is_cika
						}
					})
				}
				
			}
		},
		// 选择日期
		confirmTime(val){
			console.log(val)
			var that = this
			that.timeFormat(val)
			that.showPicker = false
			that.showMore = true
			that.totalTickteList = []
		},
		// 时间格式 timedate date对象
		timeFormat(timedate){
			var that = this
			// 年
			that.year = timedate.getFullYear()
			// 月
			that.month = timedate.getMonth() + 1 >= 10 ? timedate.getMonth() + 1 : '0'+ (timedate.getMonth() + 1)
			// 日
			that.day = timedate.getDate() >= 10 ? timedate.getDate() : '0'+ timedate.getDate()
			// 当月的最后一天 例3月份的31号
			that.lastDayOfMonth = new Date(that.year,that.month,0).getDate()
			console.log('年月日',that.year,that.month,that.day,that.lastDayOfMonth)
			// 获取数据
			that.getData()
		},
		// 判断是否为当天 date格式 2021-03-16
		isTodayFun(date1){
			var date1 = date1 + ' ' + '00:00:00'
			var currentYear = new Date().getFullYear()
			var currentMonth = new Date().getMonth()
			var currentDay = new Date().getDate()
			var timeDate1 = new Date(date1.replace(/-/g, "/")).getTime()
			var timeDate2 = new Date(currentYear,currentMonth,currentDay,'00','00','00').getTime()
			if(timeDate1 == timeDate2){
				return 1
			}else {
				return 0
			}
		},
		// 判断场次是否允许购买 date 2021-02-16  endTime 08:00:00
		isBuyFun(date,endTime){
			var time = date + ' ' + endTime
			var endTimeLine = new Date(time.replace(/-/g, "/")).getTime()
			var currentTimeLine = new Date().getTime()
			// console.log('是否允许购买',endTimeLine,currentTimeLine)
			// 结束时间在当前时间之后,为可用状态
			if(endTimeLine > currentTimeLine){
				return 1
			}else{
				return 0
			}
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
